import React, {FC} from 'react';
import {FormNameEnum} from 'filters-selections';
import {TextInputSelection} from '../TextInputSelection/TextInputSelection';
import {IWithDisabled} from 'models/common';
import {RESOURCE_FIELD_TOOLTIPS} from '../../../utils/tooltipConstants';

type Props = IWithDisabled;

export const StockImageLinkNumberInput: FC<Props> = ({disabled}) => (
  <TextInputSelection name={FormNameEnum.stockImageLinkNumber} label="Stock Image Link Number" disabled={disabled} />
);

export const AlternateTextInput: FC<Props> = ({disabled}) => (
  <TextInputSelection
    name={FormNameEnum.alternateText}
    label="Alt Text"
    disabled={disabled}
    infoText={RESOURCE_FIELD_TOOLTIPS.altText}
  />
);

export const LinkToStockImageSourceInput: FC<Props> = ({disabled}) => (
  <TextInputSelection
    name={FormNameEnum.linkToStockImageSource}
    label="Link to Stock Image Source"
    disabled={disabled}
    infoText={RESOURCE_FIELD_TOOLTIPS.linkToStockImageSource}
  />
);

export const SlideNumberInput: FC<Props> = ({disabled}) => (
  <TextInputSelection
    name={FormNameEnum.slideNumber}
    label="Slide Number"
    disabled={disabled}
    infoText={RESOURCE_FIELD_TOOLTIPS.slideNumber}
    digitsOnly
    max="999"
  />
);

export const SessionThemeNumberInput: FC<Props> = ({disabled}) => (
  <TextInputSelection
    name={FormNameEnum.sessionThemeNumber}
    label="Session/Theme/Topic Number"
    disabled={disabled}
    infoText={RESOURCE_FIELD_TOOLTIPS.sessionThemeTopicNumber}
    digitsOnly
    allowDecimal
  />
);

export const NumberOfResourcesInput: FC<Props> = ({disabled}) => (
  <TextInputSelection name={FormNameEnum.numberOfResources} label="Number of Resources" disabled={disabled} />
);

export const VideoTranscriptionLinkInput: FC<Props> = ({disabled}) => (
  <TextInputSelection name={FormNameEnum.videoTranscriptionLink} label="Video Transcript Link" disabled={disabled} />
);

export const AccessibilityStatusInput: FC<Props> = ({disabled}) => (
  <TextInputSelection name={FormNameEnum.accessibilityStatus} label="Accessibility Status" disabled={disabled} />
);

export const UrlSourceInput: FC<Props> = ({disabled}) => (
  <TextInputSelection name={FormNameEnum.urlSource} label="Media Rights URL Source" disabled={disabled} />
);

export const UsageTypeInput: FC<Props> = ({disabled}) => (
  <TextInputSelection name={FormNameEnum.usageType} label="Usage Type" disabled={disabled} />
);

export const PermissionAgreementUrlInput: FC<Props> = ({disabled}) => (
  <TextInputSelection name={FormNameEnum.permissionAgreementUrl} label="Permission Agreement URL" disabled={disabled} />
);

export const DirectoryLinkInput: FC<Props> = ({disabled}) => (
  <TextInputSelection
    name={FormNameEnum.link}
    label="Directory Link"
    disabled={disabled}
    infoText={RESOURCE_FIELD_TOOLTIPS.directoryLink}
  />
);

export const AccessibilityReportsInput: FC<Props> = ({disabled}) => (
  <TextInputSelection name={FormNameEnum.accessibilityReports} label="Accessibility Reports" disabled={disabled} />
);
